// extracted by mini-css-extract-plugin
export default {"job-results-container":"IsJAMg","action-row-container":"PUimVA"};